import React from 'react'
import {UncontrolledCarousel} from 'reactstrap'

const items = [
    {key: '1', src: '/assets/slider/slide-02.jpg', caption: ''},
    {key: '2', src: '/assets/slider/slide-03.jpg', caption: ''},
    {key: '3', src: '/assets/slider/slide-01.jpg', caption: ''},
]

const Slider = () => <UncontrolledCarousel items={items} />

export default Slider



// WEBPACK FOOTER //
// ./src/components/Slider.js